"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var conversions = require("webidl-conversions");
var utils = require("./utils.js");
var EventModifierInit = require("./EventModifierInit.js");
exports._convertInherit = function (globalObject, obj, ret) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? "The provided value" : _ref$context;
  EventModifierInit._convertInherit(globalObject, obj, ret, {
    context: context
  });
  {
    var key = "changedTouches";
    var value = obj === undefined || obj === null ? undefined : obj[key];
    if (value !== undefined) {
      if (!utils.isObject(value)) {
        throw new globalObject.TypeError(context + " has member 'changedTouches' that" + " is not an iterable object.");
      } else {
        var V = [];
        var tmp = value;
        var _iterator = _createForOfIteratorHelper(tmp),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var nextItem = _step.value;
            nextItem = utils.tryImplForWrapper(nextItem);
            V.push(nextItem);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        value = V;
      }
      ret[key] = value;
    } else {
      ret[key] = [];
    }
  }
  {
    var _key = "targetTouches";
    var _value = obj === undefined || obj === null ? undefined : obj[_key];
    if (_value !== undefined) {
      if (!utils.isObject(_value)) {
        throw new globalObject.TypeError(context + " has member 'targetTouches' that" + " is not an iterable object.");
      } else {
        var _V = [];
        var _tmp = _value;
        var _iterator2 = _createForOfIteratorHelper(_tmp),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _nextItem = _step2.value;
            _nextItem = utils.tryImplForWrapper(_nextItem);
            _V.push(_nextItem);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        _value = _V;
      }
      ret[_key] = _value;
    } else {
      ret[_key] = [];
    }
  }
  {
    var _key2 = "touches";
    var _value2 = obj === undefined || obj === null ? undefined : obj[_key2];
    if (_value2 !== undefined) {
      if (!utils.isObject(_value2)) {
        throw new globalObject.TypeError(context + " has member 'touches' that" + " is not an iterable object.");
      } else {
        var _V2 = [];
        var _tmp2 = _value2;
        var _iterator3 = _createForOfIteratorHelper(_tmp2),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _nextItem2 = _step3.value;
            _nextItem2 = utils.tryImplForWrapper(_nextItem2);
            _V2.push(_nextItem2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        _value2 = _V2;
      }
      ret[_key2] = _value2;
    } else {
      ret[_key2] = [];
    }
  }
};
exports.convert = function (globalObject, obj) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? "The provided value" : _ref2$context;
  if (obj !== undefined && _typeof(obj) !== "object" && typeof obj !== "function") {
    throw new globalObject.TypeError("".concat(context, " is not an object."));
  }
  var ret = Object.create(null);
  exports._convertInherit(globalObject, obj, ret, {
    context: context
  });
  return ret;
};